import { createActionsHook } from 'src/lib/sweetState';

import { Store } from './Store';

export const useActions = createActionsHook(Store);
